module.exports = __webpack_public_path__ + "static/media/createReturnOrderNavigation.cbc4c399.png";